export default __webpack_public_path__ + "static/media/P310.323c239d.jpg";